import { useState } from 'react';

const useSwitchRestaurant = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);

  const switchRestaurant = async (restaurantId) => {
    setIsLoading(true);
    setError(null);

    try {
      
      const response = await fetch(`${process.env.REACT_APP_BACKEND_STAGING_URL}/api/switch-restaurant`, {
        method: 'POST',
        credentials: 'include',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ restaurantId }),
      });

      if (response.ok) {
        const data = await response.json();
        
        // Dispatch event to notify components that restaurant was switched
        setTimeout(() => {
          window.dispatchEvent(new CustomEvent('restaurantSwitched', { detail: { restaurantId } }));
        }, 100);
        
        return { success: true, data };
      } else {
        const errorData = await response.json();
        setError(errorData.message || 'Failed to switch restaurant');
        return { success: false, error: errorData.message };
      }
    } catch (err) {
      console.error('❌ useSwitchRestaurant error:', err);
      setError(err.message || 'Failed to switch restaurant');
      return { success: false, error: err.message };
    } finally {
      setIsLoading(false);
    }
  };

  return { switchRestaurant, isLoading, error };
};

export default useSwitchRestaurant;
